<template>
  <section class="section-two bg-light mt-5 mb-5">
    <div class="container">
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Carregando...</span>
        </div>
        <p class="mt-2">Carregando dados do pagamento...</p>
      </div>

      <div v-else-if="error" class="alert alert-danger" role="alert">
        {{ error }}
        <div class="mt-2">
          <router-link to="/" class="btn btn-outline-primary">Voltar ao início</router-link>
        </div>
      </div>

      <div v-else class="row justify-content-center">
        <div class="col-lg-8">
          <div class="card border-0 shadow rounded mb-4">
            <div class="card-body">
              <h5 class="card-title mb-3">Resumo da consulta</h5>
              <p class="mb-1"><strong>Profissional:</strong> {{ checkoutData.schedule.prof_name }}</p>
              <p class="mb-1"><strong>Especialidade:</strong> {{ checkoutData.schedule.spec_name }}</p>
              <p class="mb-1"><strong>Local:</strong> {{ checkoutData.schedule.place_name }}</p>
              <p class="mb-1"><strong>Data e hora:</strong> {{ formatDate(checkoutData.schedule.sched_date) }} às {{ checkoutData.schedule.sched_time }}</p>
              <p class="mb-0"><strong>Valor:</strong> R$ {{ formatValue(checkoutData.value) }}</p>
            </div>
          </div>

          <div class="card border-0 shadow rounded">
            <div class="card-body">
              <h5 class="card-title mb-3">Pagamento com cartão de crédito</h5>

              <CreditCardAS
                v-if="checkoutData.card_administrator_code === 'AS'"
                @onSubmit="onSubmitCard"
              />
              <CreditCardEF
                v-else-if="checkoutData.card_administrator_code === 'EF'"
                @onSubmit="onSubmitCard"
              />
              <CreditCardGN
                v-else-if="checkoutData.card_administrator_code === 'GN'"
                @onSubmit="onSubmitCard"
              />
              <CreditCardMP
                v-else-if="checkoutData.card_administrator_code === 'MP'"
                @onSubmit="onSubmitCard"
              />
              <div v-else class="alert alert-warning">
                Gateway de pagamento "{{ checkoutData.card_administrator_code }}" não suportado nesta página. Entre em contato com o estabelecimento.
              </div>

              <p v-if="submitError" class="text-danger mt-2 mb-0">{{ submitError }}</p>
              <div v-if="paying" class="mt-2">
                <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                Processando pagamento...
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import http from "../../helpers/http";
import Alert from "../../helpers/alert";
import CreditCardAS from "../toSchedule/gateways/CreditCardAS.vue";
import CreditCardEF from "../toSchedule/gateways/CreditCardEF.vue";
import CreditCardGN from "../toSchedule/gateways/CreditCardGN.vue";
import CreditCardMP from "../toSchedule/gateways/CreditCardMP.vue";

export default {
  name: "ScheduleCardCheckout",
  components: { CreditCardAS, CreditCardEF, CreditCardGN, CreditCardMP },
  data() {
    return {
      idCardTrans: null,
      checkoutData: null,
      loading: true,
      error: null,
      submitError: null,
      paying: false,
    };
  },
  mounted() {
    this.idCardTrans = this.$route.params.id;
    if (!this.idCardTrans) {
      this.error = "Link inválido.";
      this.loading = false;
      return;
    }
    this.fetchCheckoutData();
  },
  methods: {
    fetchCheckoutData() {
      this.loading = true;
      this.error = null;
      http
        .get(`card-transactions/${this.idCardTrans}/checkout-data`)
        .then((response) => {
          this.checkoutData = response.data;
          this.$store.commit("toSchedule/setCheckoutCardContext", {
            card_administrator_code: this.checkoutData.card_administrator_code,
          });
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          const msg = err.response?.data?.error || err.response?.data?.message || "Não foi possível carregar os dados. Link pode ter expirado.";
          this.error = msg;
        });
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      const [y, m, d] = dateStr.split("-");
      return `${d}/${m}/${y}`;
    },
    formatValue(value) {
      if (value == null) return "0,00";
      return Number(value).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    onSubmitCard(payload) {
      this.submitError = null;
      this.paying = true;
      const body = {
        gateway_payment_credit_card_data: payload,
        installments: payload.installments || 1,
      };
      http
        .post(`card-transactions/${this.idCardTrans}/pay`, body)
        .then(() => {
          this.paying = false;
          Alert.success("Pagamento realizado com sucesso! Você receberá a confirmação no WhatsApp.");
          this.$router.push("/");
        })
        .catch((err) => {
          this.paying = false;
          this.submitError = err.response?.data?.error || "Falha ao processar o pagamento. Verifique os dados do cartão e tente novamente.";
        });
    },
  },
};
</script>

<style scoped>
</style>
